// API base URLs — always use api.travel-code.com (single REST API for all brands)
export const API_BASE = process.env.API_BASE_URL || "https://api.travel-code.com/v1";
export const API_TRAVELHUB_BASE = process.env.API_TRAVELHUB_URL || "https://api.travelhub.by";

// Robert AI chat backend (robert-service) runs on its own host, separate from the
// platform REST API. Override at build with ROBERT_CHAT_URL.
export const ROBERT_CHAT_BASE = process.env.ROBERT_CHAT_URL || "https://robert.travel-code.com/chat";

// Visa pipeline backend (visa-service) — same deploy pattern as robert-service.
// Override at build with VISA_SERVICE_URL.
export const VISA_SERVICE_BASE = process.env.VISA_SERVICE_URL || "https://visa.travel-code.com";
